export default "__VITE_ASSET__CqTvZBAf__"